import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DevHeader from './DevHeader';
import DevSidebar from './DevSidebar';
import DevRouteGuard from '../../../dev-dashboard/components/DevRouteGuard';

import DevOverviewPage from '../../../dev-dashboard/pages/DevOverviewPage';
import DevActivityPage from '../../../dev-dashboard/pages/DevActivityPage';
import DevCollectionsExplorerPage from '../../../dev-dashboard/pages/DevCollectionsExplorerPage';
import DevSecurityAuditPage from '../../../dev-dashboard/pages/DevSecurityAuditPage';
import DevSystemHealthPage from '../../../dev-dashboard/pages/DevSystemHealthPage';
import DevIdentityAccessPage from '../../../dev-dashboard/pages/DevIdentityAccessPage';
import DevMessagingPage from '../../../dev-dashboard/pages/DevMessagingPage';
import DevDocumentsKnowledgePage from '../../../dev-dashboard/pages/DevDocumentsKnowledgePage';
import DevProgramsOpsPage from '../../../dev-dashboard/pages/DevProgramsOpsPage';
import DevProductDevPage from '../../../dev-dashboard/pages/DevProductDevPage';
import DevTemplatesPage from '../../../dev-dashboard/pages/DevTemplatesPage';
import DevDataQualityPage from '../../../dev-dashboard/pages/DevDataQualityPage';
import DevToolsPage from '../../../dev-dashboard/pages/DevToolsPage';
import HttpReferencePage from '../../../dev-dashboard/pages/HttpReferencePage';

const DevDashboard = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedSection, setSelectedSection] = useState('overview');

  return (
    <DevRouteGuard>
      <div className="flex h-screen overflow-hidden bg-slate-950">
        <DevSidebar
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
          selected={selectedSection}
          setSelected={setSelectedSection}
        />
        <div className="relative flex min-w-0 flex-1 flex-col">
          <DevHeader />
          <main className="flex-1 overflow-y-auto bg-slate-900/50 p-4 md:p-6">
            <Routes>
              <Route path="/" element={<Navigate to="overview" replace />} />
              <Route path="overview" element={<DevOverviewPage />} />
              <Route path="overview/activity" element={<DevActivityPage />} />
              <Route path="collections" element={<DevCollectionsExplorerPage />} />
              <Route path="security" element={<DevSecurityAuditPage />} />
              <Route path="security/health" element={<DevSystemHealthPage />} />
              <Route path="identity" element={<DevIdentityAccessPage />} />
              <Route path="identity/deleted" element={<DevIdentityAccessPage />} />
              <Route path="identity/otp" element={<DevIdentityAccessPage />} />
              <Route path="clients" element={<DevIdentityAccessPage />} />
              <Route path="clients/organizations" element={<DevIdentityAccessPage />} />
              <Route path="programs" element={<DevProgramsOpsPage />} />
              <Route path="programs/sessions" element={<DevProgramsOpsPage />} />
              <Route path="programs/coaching" element={<DevProgramsOpsPage />} />
              <Route path="programs/tasks" element={<DevProgramsOpsPage />} />
              <Route path="product-dev" element={<DevProductDevPage />} />
              <Route path="product-dev/submissions" element={<DevProductDevPage />} />
              <Route path="product-dev/audits" element={<DevProductDevPage />} />
              <Route path="knowledge" element={<DevDocumentsKnowledgePage />} />
              <Route path="knowledge/analytics" element={<DevDocumentsKnowledgePage />} />
              <Route path="messaging" element={<DevMessagingPage />} />
              <Route path="messaging/private" element={<DevMessagingPage />} />
              <Route path="templates" element={<DevTemplatesPage />} />
              <Route path="templates/analytics" element={<DevTemplatesPage />} />
              <Route path="documents" element={<DevDocumentsKnowledgePage />} />
              <Route path="data-quality" element={<DevDataQualityPage />} />
              <Route path="tools" element={<DevToolsPage />} />
              <Route path="http" element={<HttpReferencePage />} />
            </Routes>
          </main>
        </div>
      </div>
    </DevRouteGuard>
  );
};

export default DevDashboard;
